export default "__VITE_ASSET__710504ba__"